<button type="button" class="btn" [ngClass]="disabled ? '' : 'enable'" (click)="clickCusto.emit()" [disabled]="disabled">
    <mat-icon *ngIf="icon">
        {{ icon }}
    </mat-icon>
    <span [ngClass]="icon ? 'content':''">
        {{ content }}
    </span>
</button>
